<form [formGroup]="addressForm" *ngIf="addressForm">
    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.STREET' | translate }}{{ hasRequiredField(street) ? '*' : '' }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'street'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.STREET',
                inputId: 'street',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="street.valid"
        >
            <app-form-errors
                [readOnly]="readOnly"
                *ngIf="street.touched"
                [errors]="street.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.STREET-NUMBER' | translate }}{{ hasRequiredField(homeNumber) ? '*' : '' }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'home_number'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.STREET-NUMBER',
                inputId: 'streetNumber',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="8"
            [isValid]="homeNumber.valid"
            [pattern]="'[0-9A-Za-z]*'"
        >
            <app-form-errors
                [readOnly]="readOnly"
                *ngIf="homeNumber.touched"
                [errors]="homeNumber.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.BOX' | translate }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'box'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.BOX',
                inputId: 'box',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="8"
            [isValid]="box.valid"
            [pattern]="'[0-9A-Za-z]*'"
        >
            <app-form-errors
                    [readOnly]="readOnly"
                    *ngIf="box.touched"
                    [errors]="box.errors"
                    (errorDisplay)="elementSizeModification.emit()"
                ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.ADDITIONAL-INFO' | translate }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'additional_information'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.ADDITIONAL-INFO',
                inputId: 'additionalInformation',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="additionalInformation.valid"
        ></app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.POSTAL-CODE' | translate }}{{ hasRequiredField(postalCode) ? '*' : '' }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'postal_code'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.POSTAL-CODE',
                inputId: 'postalCode',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="8"
            [isValid]="postalCode.valid"
        >
            <app-form-errors
                [readOnly]="readOnly"
                *ngIf="postalCode.touched"
                [errors]="postalCode.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.CITY' | translate }}{{ hasRequiredField(city) ? '*' : '' }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'city'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.CITY',
                inputId: 'city',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="city.valid"
        >
            <app-form-errors
                [readOnly]="readOnly"
                *ngIf="city.touched"
                [errors]="city.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>

    <div class="form-control">
        <label>{{ 'REPERTOIRE.FORMS.ADDRESS.LABELS.COUNTRY' | translate }}{{ hasRequiredField(country) ? '*' : '' }}</label>
        <app-basic-input
            (blur)="markAsTouched()"
            (input)="onInput()"
            [readOnly]="readOnly"
            [formControlName]="'country'"
            [inputConfig]="{
                placeholder: readOnly ? '' : 'REPERTOIRE.FORMS.ADDRESS.PLACEHOLDERS.COUNTRY',
                inputId: 'country',
                type: basicInputTypeEnum.TEXT
            }"
            [maxLength]="255"
            [isValid]="country.valid"
        >
            <app-form-errors
                [readOnly]="readOnly"
                *ngIf="country.touched"
                [errors]="country.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
</form>
